import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { BatchPaymentVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { BATCH_ORGANIZER_TYPE } from "@academy-context/shared/domain/types/enums/batch-organizer-type";

export const retrieveProviderBatchParticipationPaymentList = createAsyncThunk<BatchPaymentVM[], void, { extra: Partial<Dependencies> }>(
  "providers/retrieveProviderBatchParticipationPaymentList",
  async (_, { extra: { adminRepository } }) => {
    return adminRepository!.listBatchPayments(BATCH_ORGANIZER_TYPE.PROVIDER);
  },
);

export const resetRetrieveProviderBatchParticipationPaymentList = createAction(
  "providers/resetRetrieveProviderBatchParticipationPaymentList",
);
